<template>
  <div>
    <el-tabs v-model="activeName" style="margin-top: 10px;margin-left: 10px">
      <el-tab-pane label="体检列表" name="first" :lazy=true>
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-card class="box-card" shadow="hover">
                <el-row>
                  <el-table
                      :data="tijian_list"
                      height="600px"
                      :header-cell-style="{background:'#363944',color:'white',border:'none'}"
                      :row-class-name="tableRowClassName">
                    <el-table-column type="index" label="序号" align="center"></el-table-column>
                    <el-table-column prop="BRXM00" sortable label="姓名"></el-table-column>
                    <el-table-column prop="BRNL00" sortable label="年龄"></el-table-column>
                    <el-table-column prop="BRXB00" sortable label="性别"></el-table-column>
                    <el-table-column prop="XX0000" sortable label="血型"></el-table-column>
                    <el-table-column prop="BRID00" sortable label="病人ID" v-if="false"></el-table-column>
                    <el-table-column prop="GHID00" :show-overflow-tooltip="true" sortable
                                     label="挂号ID"></el-table-column>
                    <el-table-column prop="DWZBID" sortable label="组别ID"></el-table-column>
                    <el-table-column prop="DWID00" sortable label="单位ID"></el-table-column>
                    <el-table-column prop="DWLBID" sortable label="单位类别"></el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="open_detail(scope.row)" type="text" style="color: rgb(46, 205, 129);"
                                   size="small">详情
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-row>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>


<script>
import { buildAppWebUrl } from '@/utils/appWebUrl'

export default {
  name: "TijianMain",
  data() {
    return {
      activeName: "first",
      tijian_list: null,
    }
  },
  mounted() {
    this.get_tijian_list();
  },
  methods: {
    open_detail(row) {
      window.open(buildAppWebUrl(`/thirdParty/tijian_info?brid=${row.BRID00}`), '_blank', 'noopener,noreferrer');
    },

    get_tijian_list() {
      this.$http.get(process.env.VUE_APP_API_HOST + "/third_party/tijian_list").then((res) => {
        // console.log(res);
        this.tijian_list = res.data.data;
      })
    },
    tableRowClassName({rowIndex}) {
      if (rowIndex % 2 == 1) {
        return 'warning-row1';
      } else if (rowIndex % 2 == 0) {
        return 'success-row1';
      }
      return '';
    },
  }
}
</script>

<style scoped>
.el-table /deep/ tbody tr:hover {
  color: black !important
}

.el-table /deep/ .warning-row1 {
  background: #363944;
}

.el-table /deep/ .warning-row1 > td {
  border: none;
}

.el-table /deep/ .success-row1 {
  background: #3C3F4A;
}

.el-table /deep/ .success-row1 > td {
  border: none;
}

.el-card /deep/ .el-card__header {
  border-bottom: none;
  height: 40px;
  padding: 10px 20px;
}

.el-card /deep/ .el-card__body {
  background-color: #363944;
}


/deep/ .el-tabs__item {
  color: white !important;
  font-size: 20px;
}

/deep/ .el-tabs__item.is-active {
  color: white !important;
  font-size: 20px;
}

/deep/ .el-tabs__active-bar {
  background-color: #68F5B9 !important;

}
</style>

